import { Pagination } from '@/constants/pagination';
import { PaginationAPI } from '@/types/pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type SheetState = {
  dataAllSheet: SheetType[];
  dataAllSheetDetailTable: SheetDetailTableType[];
  dataSheetDetail?: SheetDetailType;
  pagination: PaginationAPI;
  totalElements?: number;
};

export const sheetInitialState: SheetState = {
  dataAllSheet: [],
  dataAllSheetDetailTable: [],
  pagination: {
    pageNumber: Pagination.pageNumber,
    totalPages: 0,
    totalElements: 0,
    pageSize: Pagination.pageSize,
  },
};

export const slice = createSlice({
  name: 'sheet',
  initialState: sheetInitialState,
  reducers: {
    setListSheetAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: SheetType[];
        pagination?: PaginationAPI;
        totalElements?: number;
      }>,
    ) {
      state.dataAllSheet = payload.data;
      state.pagination = payload.pagination || state.pagination;
      state.totalElements = payload.pagination?.totalElements;
    },
    setListSheetDetailTableAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: SheetDetailTableType[];
        pagination?: PaginationAPI;
        totalElements?: number;
      }>,
    ) {
      state.dataAllSheetDetailTable = payload.data;
      state.pagination = payload.pagination || state.pagination;
      state.totalElements = payload.pagination?.totalElements;
    },
    setDetailSheetAction(state, { payload }: PayloadAction<{ data: SheetDetailType }>) {
      state.dataSheetDetail = payload.data;
    },

    addSheetAction(state, { payload }: PayloadAction<SheetType>) {
      state.dataAllSheet = [payload, ...state.dataAllSheet];
      state.pagination = {
        ...state.pagination,
        pageSize: state.pagination.pageSize + 1,
        totalElements: state.pagination.totalElements + 1,
      };
    },

    addSheetTabAction(state, { payload }: PayloadAction<SheetDetailTableType>) {
      state.dataAllSheetDetailTable = [payload, ...state.dataAllSheetDetailTable];
      state.pagination = {
        ...state.pagination,
        pageSize: state.pagination.pageSize + 1,
        totalElements: state.pagination.totalElements + 1,
      };
    },

    editSheetTabAction(state, { payload }: PayloadAction<SheetDetailTableType>) {
      state.dataAllSheetDetailTable = state.dataAllSheetDetailTable.map((item) => {
        if (item?.id === payload?.id) {
          return payload;
        }
        return item;
      });
    },

    deleteSheetAction(state, { payload }: PayloadAction<string>) {
      state.dataAllSheet = state.dataAllSheet.filter((item) => !payload.includes(item.id!));
    },

    editSheetAction(state, { payload }: PayloadAction<SheetType>) {
      state.dataAllSheet = state.dataAllSheet.map((item) => {
        if (item?.id === payload?.id) {
          return payload;
        }
        return item;
      });
    },
  },
});

export const {
  setListSheetAction,
  setListSheetDetailTableAction,
  setDetailSheetAction,
  addSheetAction,
  addSheetTabAction,
  editSheetTabAction,
  deleteSheetAction,
  editSheetAction,
} = slice.actions;

export default slice.reducer;
